/**
 * Detects the specific `clips/angles` failure where the underlying recording isn't a
 * play-based continuous playlist (i.e. clipped video download will never be available for
 * this event), as opposed to any other/transient error fetching clip angles.
 */
export function isClipAnglesNotContinuousPlaylistError(error: unknown): boolean {
  if (!isH3Error(error) || !isAtlitError(error)) return false;

  const [firstError] = error.data.errors;
  if (firstError?.statusCode !== "VSError") return false;

  // VS service surfaces this as a generic 500/VSError with a free-text `error`
  // message rather than a dedicated error code, so we have to pattern-match on the message to
  // tell "this recording has no clips by design" apart from any other failure.
  const CLIP_ANGLES_NOT_CONTINUOUS_PLAYLIST_MESSAGE = "not a playbased continuous playlist";

  try {
    const details = JSON.parse(firstError.details) as { error?: string };
    return typeof details?.error === "string" && details.error.includes(CLIP_ANGLES_NOT_CONTINUOUS_PLAYLIST_MESSAGE);
  } catch {
    return false;
  }
}
